import { jsx as _jsx } from "react/jsx-runtime";
import { cva } from "class-variance-authority";
import { cn } from "../../lib/cn";
/**
 * A text field, measured from `.fld input`.
 *
 * The brand's fields sit one step BELOW the page ground (`--lg-bg-2`) rather
 * than above it, which is what makes them read as inset when they are on a
 * card. That is the detail people get wrong when rebuilding this by eye.
 *
 * The source page's focus state is `outline: none` plus a border recolour.
 * This adds a ring, for the reason in bpg-brand-data-intelligence.md §7.
 */
export const inputVariants = cva([
    "lg:w-full lg:rounded-[8px] lg:border lg:border-input lg:bg-brand-bg2",
    "lg:px-3.5 lg:py-3 lg:text-body-sm lg:text-strong",
    "lg:placeholder:text-subtle lg:transition-colors lg:duration-150",
    "lg:outline-none lg:focus-visible:ring-2 lg:focus-visible:ring-ring",
    "lg:focus-visible:ring-offset-2 lg:focus-visible:ring-offset-background",
    "lg:disabled:cursor-not-allowed lg:disabled:opacity-50",
    "lg:aria-invalid:border-destructive lg:aria-invalid:focus-visible:ring-destructive",
    "lg:file:border-0 lg:file:bg-transparent lg:file:text-body-sm lg:file:font-label",
], {
    variants: {
        inputSize: {
            sm: "lg:py-2 lg:text-caption",
            md: "",
        },
        /**
         * The one-time passcode field from the gate pages: mono, wide tracking,
         * centred. Pair it with `inputMode="numeric"` and
         * `autoComplete="one-time-code"`, which this component does not set for
         * you because a six-digit code and an alphanumeric one want different
         * keyboards.
         */
        code: {
            true: "lg:font-mono lg:text-[24px] lg:tracking-[0.4em] lg:text-center lg:py-3.5",
            false: "",
        },
    },
    defaultVariants: { inputSize: "md", code: false },
});
export function Input({ className, inputSize, code, type = "text", ...props }) {
    return (_jsx("input", { "data-slot": "input", type: type, className: cn(inputVariants({ inputSize, code }), className), ...props }));
}
//# sourceMappingURL=input.js.map